import { useEffect, useRef } from "react";

const useCallbackRef = (callback = () => {}) => {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  return callbackRef;
};

export default useCallbackRef;
